<template>
	<div>
		<b-button v-if="isMyPage" type="is-primary" class="max-w-button highly-button" @click="$router.push({ name: 'news-new'})">
			<div class="horizontal-center-center button-icon-right">
				<span>記事を書く</span><img :src="require('@/assets/icons/news_edit_big.svg')">
			</div>
		</b-button>

		<b-button v-else type="is-primary" class="max-w-button highly-button" @click="$router.push({ name: 'coin-present-to-staff', params: { staffId: id }})">
			<div class="horizontal-center-center button-icon-right">
				<span>この人にコインを贈る</span><img :src="require('@/assets/icons/coin_big.svg')">
			</div>
		</b-button>

		<div class="avatar-area mt-10">
			<div class="text-center">
				<avatar :image="avatar" :clickable="false" :width="151"></avatar>
				<div class="kana mt-20">{{ nameKana }}</div>
				<div class="bold18">{{ name }}</div>
			</div>

			<ul v-if="isMyPage" class="button-area horizontal-center mt-30">
				<li>
					<div class="button-wrap text-center" @click="$router.push({ name: 'staff-edit' })">
						<img :src="require('@/assets/icons/my_page/gear.svg')">
						<span class="button-text">設定</span>
					</div>
				</li>
				<li v-if="!$utils.isApp()">
					<div class="button-wrap text-center" @click="$router.push({ name: 'notification' })">
						<img :src="require('@/assets/icons/my_page/bell.svg')">
						<span class="button-text">メール通知</span>
					</div>
				</li>
				<li>
					<div class="button-wrap text-center" @click="$router.push({ name: 'prize' })">
						<img :src="require('@/assets/icons/my_page/gift.svg')">
						<span class="button-text">景品交換</span>
					</div>
				</li>
				<li>
					<div class="button-wrap text-center" @click="$router.push({ name: 'team-new' })">
						<img :src="require('@/assets/icons/my_page/team.svg')">
						<span class="button-text">チームを作る</span>
					</div>
				</li>
			</ul>

			<component :is="currentTableComponent" class="mt-40" :data="data"></component>

			<div class="mt-30 mb-20 section-title" style="margin-left: 0;">加入中のチーム</div>

			<div class="horizontal-center bold18 staff-teams" v-for="(row, index) in staffTeams" :key="index" @click="$router.push({ name: 'team', params: { teamId: row.team_id }})">
				<span>{{ row.name}}</span>
				<span v-if="row.is_organizer" class="organizer">★主催</span>
			</div>
		</div>

		<div class="mt-40 mb-20 tm section-title">自己紹介</div>

		<div class="profiles">
			<div class="profile-wrap mt-10" v-for="(row, index) in staffProfiles" :key="index">
				<div class="profile-title">{{ row.title }}</div>
				<div class="profile-body word-wrap">{{ row.body }}</div>
			</div>

			<div class="profile-wrap" v-for="n in profileDummy" :key="'profileDummy' + n"></div>
		</div>


		<div class="mt-40 mb-20 section-title">獲得・贈呈コイン枚数</div>

		<summary-period-select :dateProvided="dateProvided" @period-change="onSummaryPeriodChange" @end-change="onSummaryPeriodEndChange" @start-change="onSummaryPeriodStartChange"></summary-period-select>

		<b-button type="is-success" class="max-w-button mt-30 mb-50" :loading="isSummarySearchLoading" @click="onSummarySearchButtonClick">表示する</b-button>

		<div class="mt-40 mb-5 period-title" style="font-size: 14px">集計期間：{{ period }}（前日集計）</div>

		<div class="summary-wrap" v-for="row in summary" :key="row.coin_id">
			<div class="coin-wrap horizontal-center mb-10">
				<img :src="row.coin_image"/>
				<div class="bold18 ml-10 coin-name">{{ row.coin_name }}コイン</div>
			</div>

			<div class="count-wrap horizontal-center">
				<div class="summary recieve-wrap horizontal-center">
					<div class="summary-header recieve-header">獲得</div>
					<div class="summary-count recieve-count bold18">{{ row.recieve_count }}枚</div>
				</div>

				<div class="summary present-wrap horizontal-center">
					<div class="summary-header present-header">贈呈</div>
					<div class="summary-count present-count bold18">{{ row.present_count }}枚</div>
				</div>
			</div>
		</div>

		<div class="mt-40 mb-20 section-title">7Coins</div>

		<div v-if="coins.list && coins.list.length > 0" class="coin-card-wrap">
			<coin-card
				class="mt-10"
				v-for="row in coins.list"
				:key="row.id"
				:isTeam="row.is_team"
				:id="row.id"
				:coin="row.coin"
				:comment="row.comment"
				:commentEllipsis="30"
				:to="row.is_team ? row.to_team : row.to_staff"
				:from="row.from"
				:created="row.created"
				:likeCount="row.like_count"
				:isLiked="row.is_liked"
				:isEditShow="row.from.id === $store.state.auth.id"
				@edit-click="$router.push({ name: 'coin-present-to', params: { coinPresentId: row.id }})"
				@comment-click="$router.push({ name: '7coins', params: { coinPresentId: row.id }})"
			></coin-card>

			<coin-card
				v-for="n in coinDummy"
				:key="`card-dummy-${n}`"
				class="coin-card-dummy"
				:to="coinDummyData"
				:from="coinDummyData"
				style="visibility: hidden;"
			></coin-card>

		</div>
		<div v-else>コインはありません</div>

		<split-loader class="mt-10" :windowH="windowH" :isLoading="isSplitLoading" @base-touch="onBaseTouch"></split-loader>
	</div>
</template>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.period-title {
	margin-left: 20px;
}

.summary-wrap {
	background: #fff;
	padding: 13px 15px;
	margin-bottom: 10px;

	.count-wrap {
		justify-content: space-between;

		.summary-header {
			padding: 5px 15px;
			color: #fff;
			font-size: 14px;
			font-weight: bold;
		}

		.summary-count {
			padding: 1px 10px;
			width: 90px;
			text-align: center;
		}

		.recieve-header {
			background: $tabPink;
		}

		.recieve-count {
			border: $tabPink 1px solid;
		}

		.present-header {
			background: $tabGreen;
		}

		.present-count {
			border: $tabGreen 1px solid;
		}
	}

	.coin-wrap {
		img {
			width: 30px;
			height: 30px;
		}
	}
}

.staff-teams {
	padding: 3px 8px;
	border: $commonBorder;
	justify-content: space-between;

	&:not(:last-child) {
		border-bottom: none;
	}
}

.profile-wrap {
	& div {
		padding: 5px 20px;
	}
	.profile-title {
		background: $skyBlue;
		color: #fff;
		font-weight: $extraBold;
	}
	.profile-body {
		background: #fff;
		min-height: 70px;
		font-size: 18px;
	}
}

.avatar-area {
	background: #fff;
	margin-left: -$basePadding;
	margin-right: -$basePadding;
	padding: 30px 20px;
}

.button-area {
	justify-content: space-between;

	.button-wrap {
		img {
			display: block;
			width: 48px;
			height: 48px;
			margin: 0 auto;
		}

		.button-text {
			font-size: 12px;
		}
	}
}

@media screen and (min-width: $breakPoint) {
	.avatar-area {
		padding-left: 240px;
		padding-right: 240px;
	}

	.profiles {
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;
		align-items: baseline;

		.profile-wrap {
			margin-top: 20px !important;
			width: 382px;
		}
	}


	.period-title {
		margin-left: 62px !important;
	}

	.summary-wrap {
		display: flex;
		align-items: center;
		padding: 13px 80px;
		margin-left: 62px;
		margin-right: 62px;

		.coin-wrap {
			margin: 0 !important;
			width: 550px;

			img {
				width: 70px;
				height: 73px;
			}

			.coin-name {
				margin-left: 30px !important;
			}
		}

		.count-wrap {
			justify-content: normal;

			.summary:first-child {
				margin-right: 30px;
			}

			.summary-header {
				width: 78px;
			}

			.summary-count {
				width: 144px;
			}
		}
	}

	.coin-card-wrap {
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;

		.sv-coin-card {
			width: 301px;
			margin-top: 20px;
		}
	}
}
</style>

<script>
import moment from 'moment'
import Avatar from '@/components/Avatar'
import CurrentTable from '@/components/CurrentTable'
import SummaryPeriodSelect from '@/components/SummaryPeriodSelect'
import CoinCard from '@/components/CoinCard'
import SplitLoader from '@/components/SplitLoader'

export default {
	name: 'Staff',
	components: {
		Avatar,
		CurrentTable,
		SummaryPeriodSelect,
		CoinCard,
		SplitLoader,
	},
	data () {
		return {
			id: '',
			name: '',
			nameKana: '',
			avatar: '',
			data: null,
			currentTableComponent: null,
			isMyPage: true,
			staffProfiles: [],
			staffTeams: [],
			periodId: 0,
			period: '',
			summaryPeriodStart: moment().format('YYYY-MM'),
			summaryPeriodEnd: moment().format('YYYY-MM'),
			summary: [],
			isSummarySearchLoading: false,
			isSplitLoading: false,
			windowH: 0,
			coins: [],
			profileDummy: 0,
			coinDummy: 0,
			coinDummyData: {
				id: '',
				name: '',
				avatar: '',
			},
		}
	},
	computed: {
		dateProvided: function() {
			return moment().format('YYYY-MM-DD');
		},
	},
	created() {
	},
	mounted() {
		this.init();
		this.windowH = document.getElementsByTagName('html')[0].clientHeight;
		//setTimeout(function() {
		//	window.scrollBy(0, 900);
		//},1000);
	},
	watch: {
		'$route' (to, from) {
			this.init();
		}
	},
	methods: {
		onBaseTouch: async function(index) {
			this.$utils.log('onBottomTouch');
			this.$utils.log(typeof this.coins.last_id === 'undefined');
			if (typeof this.coins.last_id === 'undefined' || this.coins.last_id === '') {
				return;
			}
			this.isSplitLoading = true;

			let staffId = this.isMyPage ? this.$store.state.auth.id : this.$route.params.staffId;
			let ep = `present-coins/index?last_id=${this.coins.last_id}&to_staff_id=${staffId}`;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				let tmp = this.coins.list.concat(res.data.list);
				this.coins.list = tmp;
				this.updateCoinDummy();
				this.coins.last_id = res.data.last_id;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isSplitLoading = false;
			}
		},
		onSummarySearchButtonClick: async function() {
			this.isSummarySearchLoading = true;
			let staffId = this.isMyPage ? this.$store.state.auth.id : this.$route.params.staffId;
			let ep = `staffs/coin-summary?&staff_id=${staffId}&period=${this.periodId}&start=${this.summaryPeriodStart}&end=${this.summaryPeriodEnd}`;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.summary = res.data.summary;
				this.period = res.data.period;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isSummarySearchLoading = false;
			}
		},
		onSummaryPeriodChange: function(periodId) {
			this.periodId = periodId;
		},
		onSummaryPeriodStartChange: function(date) {
			this.summaryPeriodStart = date;
		},
		onSummaryPeriodEndChange: function(date) {
			this.summaryPeriodEnd = date;
		},
		updateCoinDummy: function() {
			if (this.$utils.isSp()) return;
			this.coinDummy = this.coins.length === 0 ? 0 : 4 - (this.coins.list.length % 4);
		},
		init: function() {
			this.isMyPage = !this.$route.params.staffId ? true : false;
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'staffs/view';
			ep += this.isMyPage ? '' : '/' + this.$route.params.staffId;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.data = res.data;
				this.id = res.data.id;
				this.name = res.data.name;
				this.nameKana = res.data.name_kana;
				this.avatar = res.data.avatar;
				this.staffProfiles = res.data.staff_profiles;
				this.staffTeams = res.data.staff_teams;
				this.currentTableComponent = 'current-table';
				this.period = res.data.period;
				this.summary = res.data.summary;
				this.coins = res.data.coins;
				this.updateCoinDummy();
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>
